import { graphql, readFragment, useQuery } from "@opensea/graphql";
import { UnstyledButton } from "@opensea/ui-kit";
import { CollectionWatchlistIcon } from "@/components/collection/CollectionWatchlistButton/CollectionWatchlistIcon";
import { useToggleWatchCollection, useToggleWatchCollectionFragment } from "@/components/collection/CollectionWatchlistButton/use-toggle-watch-collection";
import { withSuspense } from "@/components/suspense/WithSuspense";
import { useAddress } from "@/hooks/wallet";
const query = graphql(`
  query CollectionHeaderWatchlistButtonQuery($slug: String!) {
    isCollectionWatched(slug: $slug)
  }
`);
export const CollectionHeaderWatchlistButtonFragment = graphql(`
  fragment CollectionHeaderWatchlistButton on Collection {
    slug
    ...useToggleWatchCollection
  }
`, [useToggleWatchCollectionFragment]);
export const CollectionHeaderWatchlistButton = withSuspense(function CollectionHeaderWatchlistButton({
  collection: collectionKey,
  className
}) {
  const collection = readFragment(CollectionHeaderWatchlistButtonFragment, collectionKey);
  const address = useAddress();
  const [{
    data,
    fetching
  }] = useQuery({
    query,
    variables: {
      slug: collection.slug
    },
    pause: !address
  });
  const toggleWatch = useToggleWatchCollection({
    collection,
    isWatching: data?.isCollectionWatched ?? false
  });
  const handleWatch = async ev => {
    ev.preventDefault();
    await toggleWatch.execute();
  };
  const isFetching = fetching || toggleWatch.fetching;
  return <UnstyledButton className={className} disabled={isFetching} onClick={handleWatch}>
        <CollectionWatchlistIcon isFilled={toggleWatch.isWatching} loading={isFetching} size={20} />
      </UnstyledButton>;
}, {
  ssr: false,
  fallback: ({
    className
  }) => <UnstyledButton className={className} disabled>
        <CollectionWatchlistIcon isFilled={false} loading size={20} />
      </UnstyledButton>
});